import {DefaultTheme} from 'styled-components';
import {darken, rgba} from 'polished';

import {black, white} from './colors';

export const Master: DefaultTheme = {
    svg: {
        authors: {
            backgroundColor: darken(0.05, white),
            foregroundColor: rgba(black, 0.2)
        }
    },
    color: {
        primary: white,
        secondary: black,
        foreground: black,
        background: white
    },
    font: {
        family: {
            primary: 'sans-serif',
            secondary: 'serif'
        },
        weight: {
            light: 300,
            normal: 400,
            bold: 600,
            heavy: 900
        }
    },
    breakpoint: {
        desktop: '1025px'
    }
};

// TODO: Dark theme variant
export const DarkTheme: DefaultTheme = Master;

// TODO: alternative theme converter
export const AlternativeTheme = (currentTheme: DefaultTheme): DefaultTheme => {
    return currentTheme;
};
